/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'
import { Timestamp } from '../../google/protobuf/timestamp'
import { GachaConsumeType } from '../../Gacha/Common/GachaConsumeType'
import { GachaItem } from '../../Gacha/Common/GachaItem'
import { GachaPartsSet } from '../../Gacha/Common/GachaPartsSet'

export const protobufPackage = 'Reality.Reality.Api'

export interface Gacha {
  id: number
  /** ガチャグループID */
  groupId: string
  name: string
  priority: number
  /** "M001" or "F001" */
  original: string
  /** おまけセットID */
  bonusSetId: number
  /** reserved */
  isUseRemainingTimes: boolean
  /** reserved */
  remainingTimes: number
  bannerUrl: string
  startAt: Date | undefined
  endAt: Date | undefined
  consumeTypes: GachaConsumeType[]
  items: GachaItem[]
  autoTryOnPartsSets: GachaPartsSet[]
  /** ウェルカムセールガチャかどうか */
  isWelcomeSale: boolean
  /** 色変更ガチャかどうか */
  isColorExchangeable: boolean
  /** ガチャ排出セットID */
  setId: number
  /** レア度確定おまけ */
  rarityGuaranteeSetId: number
}

function createBaseGacha(): Gacha {
  return {
    id: 0,
    groupId: '',
    name: '',
    priority: 0,
    original: '',
    bonusSetId: 0,
    isUseRemainingTimes: false,
    remainingTimes: 0,
    bannerUrl: '',
    startAt: undefined,
    endAt: undefined,
    consumeTypes: [],
    items: [],
    autoTryOnPartsSets: [],
    isWelcomeSale: false,
    isColorExchangeable: false,
    setId: 0,
    rarityGuaranteeSetId: 0,
  }
}

export const Gacha = {
  encode(message: Gacha, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id)
    }
    if (message.groupId !== '') {
      writer.uint32(18).string(message.groupId)
    }
    if (message.name !== '') {
      writer.uint32(26).string(message.name)
    }
    if (message.priority !== 0) {
      writer.uint32(32).int64(message.priority)
    }
    if (message.original !== '') {
      writer.uint32(42).string(message.original)
    }
    if (message.bonusSetId !== 0) {
      writer.uint32(48).int64(message.bonusSetId)
    }
    if (message.isUseRemainingTimes === true) {
      writer.uint32(56).bool(message.isUseRemainingTimes)
    }
    if (message.remainingTimes !== 0) {
      writer.uint32(64).int64(message.remainingTimes)
    }
    if (message.bannerUrl !== '') {
      writer.uint32(74).string(message.bannerUrl)
    }
    if (message.startAt !== undefined) {
      Timestamp.encode(
        toTimestamp(message.startAt),
        writer.uint32(82).fork()
      ).ldelim()
    }
    if (message.endAt !== undefined) {
      Timestamp.encode(
        toTimestamp(message.endAt),
        writer.uint32(90).fork()
      ).ldelim()
    }
    for (const v of message.consumeTypes) {
      GachaConsumeType.encode(v!, writer.uint32(98).fork()).ldelim()
    }
    for (const v of message.items) {
      GachaItem.encode(v!, writer.uint32(106).fork()).ldelim()
    }
    for (const v of message.autoTryOnPartsSets) {
      GachaPartsSet.encode(v!, writer.uint32(114).fork()).ldelim()
    }
    if (message.isWelcomeSale === true) {
      writer.uint32(120).bool(message.isWelcomeSale)
    }
    if (message.isColorExchangeable === true) {
      writer.uint32(128).bool(message.isColorExchangeable)
    }
    if (message.setId !== 0) {
      writer.uint32(136).uint32(message.setId)
    }
    if (message.rarityGuaranteeSetId !== 0) {
      writer.uint32(144).int64(message.rarityGuaranteeSetId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Gacha {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGacha()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.id = longToNumber(reader.int64() as Long)
          break
        case 2:
          message.groupId = reader.string()
          break
        case 3:
          message.name = reader.string()
          break
        case 4:
          message.priority = longToNumber(reader.int64() as Long)
          break
        case 5:
          message.original = reader.string()
          break
        case 6:
          message.bonusSetId = longToNumber(reader.int64() as Long)
          break
        case 7:
          message.isUseRemainingTimes = reader.bool()
          break
        case 8:
          message.remainingTimes = longToNumber(reader.int64() as Long)
          break
        case 9:
          message.bannerUrl = reader.string()
          break
        case 10:
          message.startAt = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          )
          break
        case 11:
          message.endAt = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          )
          break
        case 12:
          message.consumeTypes.push(
            GachaConsumeType.decode(reader, reader.uint32())
          )
          break
        case 13:
          message.items.push(GachaItem.decode(reader, reader.uint32()))
          break
        case 14:
          message.autoTryOnPartsSets.push(
            GachaPartsSet.decode(reader, reader.uint32())
          )
          break
        case 15:
          message.isWelcomeSale = reader.bool()
          break
        case 16:
          message.isColorExchangeable = reader.bool()
          break
        case 17:
          message.setId = reader.uint32()
          break
        case 18:
          message.rarityGuaranteeSetId = longToNumber(reader.int64() as Long)
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): Gacha {
    return {
      id: isSet(object.id) ? Number(object.id) : 0,
      groupId: isSet(object.groupId) ? String(object.groupId) : '',
      name: isSet(object.name) ? String(object.name) : '',
      priority: isSet(object.priority) ? Number(object.priority) : 0,
      original: isSet(object.original) ? String(object.original) : '',
      bonusSetId: isSet(object.bonusSetId) ? Number(object.bonusSetId) : 0,
      isUseRemainingTimes: isSet(object.isUseRemainingTimes)
        ? Boolean(object.isUseRemainingTimes)
        : false,
      remainingTimes: isSet(object.remainingTimes)
        ? Number(object.remainingTimes)
        : 0,
      bannerUrl: isSet(object.bannerUrl) ? String(object.bannerUrl) : '',
      startAt: isSet(object.startAt)
        ? fromJsonTimestamp(object.startAt)
        : undefined,
      endAt: isSet(object.endAt) ? fromJsonTimestamp(object.endAt) : undefined,
      consumeTypes: Array.isArray(object?.consumeTypes)
        ? object.consumeTypes.map((e: any) => GachaConsumeType.fromJSON(e))
        : [],
      items: Array.isArray(object?.items)
        ? object.items.map((e: any) => GachaItem.fromJSON(e))
        : [],
      autoTryOnPartsSets: Array.isArray(object?.autoTryOnPartsSets)
        ? object.autoTryOnPartsSets.map((e: any) => GachaPartsSet.fromJSON(e))
        : [],
      isWelcomeSale: isSet(object.isWelcomeSale)
        ? Boolean(object.isWelcomeSale)
        : false,
      isColorExchangeable: isSet(object.isColorExchangeable)
        ? Boolean(object.isColorExchangeable)
        : false,
      setId: isSet(object.setId) ? Number(object.setId) : 0,
      rarityGuaranteeSetId: isSet(object.rarityGuaranteeSetId)
        ? Number(object.rarityGuaranteeSetId)
        : 0,
    }
  },

  toJSON(message: Gacha): unknown {
    const obj: any = {}
    message.id !== undefined && (obj.id = Math.round(message.id))
    message.groupId !== undefined && (obj.groupId = message.groupId)
    message.name !== undefined && (obj.name = message.name)
    message.priority !== undefined &&
      (obj.priority = Math.round(message.priority))
    message.original !== undefined && (obj.original = message.original)
    message.bonusSetId !== undefined &&
      (obj.bonusSetId = Math.round(message.bonusSetId))
    message.isUseRemainingTimes !== undefined &&
      (obj.isUseRemainingTimes = message.isUseRemainingTimes)
    message.remainingTimes !== undefined &&
      (obj.remainingTimes = Math.round(message.remainingTimes))
    message.bannerUrl !== undefined && (obj.bannerUrl = message.bannerUrl)
    message.startAt !== undefined &&
      (obj.startAt = message.startAt.toISOString())
    message.endAt !== undefined && (obj.endAt = message.endAt.toISOString())
    if (message.consumeTypes) {
      obj.consumeTypes = message.consumeTypes.map((e) =>
        e ? GachaConsumeType.toJSON(e) : undefined
      )
    } else {
      obj.consumeTypes = []
    }
    if (message.items) {
      obj.items = message.items.map((e) =>
        e ? GachaItem.toJSON(e) : undefined
      )
    } else {
      obj.items = []
    }
    if (message.autoTryOnPartsSets) {
      obj.autoTryOnPartsSets = message.autoTryOnPartsSets.map((e) =>
        e ? GachaPartsSet.toJSON(e) : undefined
      )
    } else {
      obj.autoTryOnPartsSets = []
    }
    message.isWelcomeSale !== undefined &&
      (obj.isWelcomeSale = message.isWelcomeSale)
    message.isColorExchangeable !== undefined &&
      (obj.isColorExchangeable = message.isColorExchangeable)
    message.setId !== undefined && (obj.setId = Math.round(message.setId))
    message.rarityGuaranteeSetId !== undefined &&
      (obj.rarityGuaranteeSetId = Math.round(message.rarityGuaranteeSetId))
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<Gacha>, I>>(object: I): Gacha {
    const message = createBaseGacha()
    message.id = object.id ?? 0
    message.groupId = object.groupId ?? ''
    message.name = object.name ?? ''
    message.priority = object.priority ?? 0
    message.original = object.original ?? ''
    message.bonusSetId = object.bonusSetId ?? 0
    message.isUseRemainingTimes = object.isUseRemainingTimes ?? false
    message.remainingTimes = object.remainingTimes ?? 0
    message.bannerUrl = object.bannerUrl ?? ''
    message.startAt = object.startAt ?? undefined
    message.endAt = object.endAt ?? undefined
    message.consumeTypes =
      object.consumeTypes?.map((e) => GachaConsumeType.fromPartial(e)) || []
    message.items = object.items?.map((e) => GachaItem.fromPartial(e)) || []
    message.autoTryOnPartsSets =
      object.autoTryOnPartsSets?.map((e) => GachaPartsSet.fromPartial(e)) || []
    message.isWelcomeSale = object.isWelcomeSale ?? false
    message.isColorExchangeable = object.isColorExchangeable ?? false
    message.setId = object.setId ?? 0
    message.rarityGuaranteeSetId = object.rarityGuaranteeSetId ?? 0
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function toTimestamp(date: Date): Timestamp {
  const seconds = date.getTime() / 1_000
  const nanos = (date.getTime() % 1_000) * 1_000_000
  return { seconds, nanos }
}

function fromTimestamp(t: Timestamp): Date {
  let millis = t.seconds * 1_000
  millis += t.nanos / 1_000_000
  return new Date(millis)
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o
  } else if (typeof o === 'string') {
    return new Date(o)
  } else {
    return fromTimestamp(Timestamp.fromJSON(o))
  }
}

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
